var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _ellipse2, _path52, _path53, _path54, _path55, _path56, _ellipse3, _path57, _path58, _ellipse4, _path59, _path60, _ellipse5, _path61, _path62, _ellipse6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEngineer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 676 474",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "99.997%",
    x2: "-.005%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "0%",
    x2: "100%",
    y1: "50.005%",
    y2: "50.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#FFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#FFF",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#FFF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    stopColor: "#FFF",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopColor: "#FFF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84%",
    stopColor: "#FFF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#FFF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#FFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "0%",
    x2: "100%",
    y1: "49.997%",
    y2: "49.997%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#FFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#FFF",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#FFF",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    stopColor: "#FFF",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopColor: "#FFF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84%",
    stopColor: "#FFF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#FFF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#FFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "-2.188%",
    x2: "97.913%",
    y1: "49.368%",
    y2: "49.368%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: "-.381%",
    x2: "99.708%",
    y1: "301.69%",
    y2: "301.69%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "-.224%",
    x2: "99.877%",
    y1: "233.434%",
    y2: "233.434%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__h",
    x1: "-.079%",
    x2: "100.022%",
    y1: "167.11%",
    y2: "167.11%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__i",
    x1: "-.112%",
    x2: "99.989%",
    y1: "183.634%",
    y2: "183.634%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__j",
    x1: ".045%",
    x2: "100.135%",
    y1: "116.229%",
    y2: "116.229%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__k",
    x1: ".202%",
    x2: "100.303%",
    y1: "47.967%",
    y2: "47.967%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__l",
    x1: ".348%",
    x2: "100.449%",
    y1: "-18.354%",
    y2: "-18.354%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__m",
    x1: ".314%",
    x2: "100.415%",
    y1: "-1.827%",
    y2: "-1.827%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__n",
    x1: ".774%",
    x2: "100.875%",
    y1: "-203.81%",
    y2: "-203.81%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__o",
    x1: "101.784%",
    x2: "1.683%",
    y1: "49.153%",
    y2: "49.153%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__p",
    x1: "101.358%",
    x2: "1.257%",
    y1: "49.153%",
    y2: "49.153%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__q",
    x1: "100.931%",
    x2: ".83%",
    y1: "49.155%",
    y2: "49.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C2AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0C50F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__r",
    x1: "0%",
    x2: "100%",
    y1: "50.002%",
    y2: "50.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EDFD",
    fillRule: "nonzero",
    d: "M160.848 148.194L228.997 186.546 68.314 280.393.165 242.041 160.848 148.194M515.306 201.39L675.989 295.236 607.85 333.596 447.153 239.749 515.303 201.393M595.598 339.902L286.727 167.33 78.683 286.786l-.366.213 304.61 175.017 212.671-122.114zm-408.146-59.2l106.804-61.375 207.24 118.903-.366.213.242.143-106.595 61.257L187.452 280.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "nonzero",
    d: "M303.112 0.07L481.209 105.691 394.066 154.822 215.976 49.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M481.209 105.691L481.209 338.809 394.066 387.936 394.066 154.822z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M215.976 49.2L215.976 282.314 394.066 387.936 394.066 154.822z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    d: "M303.009 10.327L463.688 104.174 395.539 142.53 234.86 48.683 303.009 10.327"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M456.419 108.437L302.984 18.806 242.177 52.701 234.849 48.401 302.995 10.254 463.802 104.174z",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0AEC1",
    fillRule: "nonzero",
    d: "M394.066 162.696L481.209 113.566 481.209 105.691 394.066 154.822z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1C9DB",
    fillRule: "nonzero",
    d: "M215.976 57.074L394.066 162.696 394.066 154.822 215.976 49.2z",
    opacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M302.995 10.254L234.849 48.401 395.528 142.534 463.802 104.174z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8DFA",
    fillRule: "nonzero",
    d: "M262.497 310.311L290.5 326.58 290.5 258.893 262.497 242.62zM317.742 342.578L345.746 358.851 345.746 291.164 317.742 274.891z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4FC0",
    fillRule: "nonzero",
    d: "M290.5 326.609L318.504 342.882 318.504 275.195 290.5 258.922z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M290.5 258.922L262.497 276.753 262.497 242.62z",
    opacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M345.746 291.164L345.746 326.58 318.504 342.882 318.504 275.389z",
    opacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M254.788 151.5L222.138 132.221 222.252 74.044 254.898 93.337z",
    opacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    fillRule: "nonzero",
    d: "M254.788 151.5L254.792 148.865 224.417 130.92 224.524 75.396 222.252 74.044 222.138 132.221 254.788 151.5z",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M299.114 177.649L266.465 158.37 266.578 100.193 299.228 119.486z",
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    fillRule: "nonzero",
    d: "M299.114 177.649L299.122 175.013 268.744 157.069 268.854 101.542 266.578 100.193 266.465 158.37 299.114 177.649z",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M343.115 204.128L310.465 184.849 310.579 126.675 343.228 145.965z",
    opacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    fillRule: "nonzero",
    d: "M343.115 204.128L343.119 201.492 312.744 183.551 312.851 128.024 310.579 126.675 310.465 184.849 343.115 204.128z",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M387.504 229.855L354.854 210.576 354.968 152.402 387.617 171.692z",
    opacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__h)",
    fillRule: "nonzero",
    d: "M387.504 229.855L387.507 227.219 357.133 209.279 357.239 153.748 354.968 152.402 354.854 210.576 387.504 229.855z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M254.788 223.326L222.138 204.047 222.252 145.87 254.898 165.163z",
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__i)",
    fillRule: "nonzero",
    d: "M254.788 223.326L254.792 220.69 224.417 202.746 224.524 147.219 222.252 145.87 222.138 204.047 254.788 223.326z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M299.114 249.475L266.465 230.196 266.578 172.018 299.228 191.312z",
    opacity: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__j)",
    fillRule: "nonzero",
    d: "M299.114 249.475L299.122 246.839 268.744 228.895 268.854 173.367 266.578 172.018 266.465 230.196 299.114 249.475z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M343.115 275.954L310.465 256.675 310.579 198.497 343.228 217.791z",
    opacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__k)",
    fillRule: "nonzero",
    d: "M343.115 275.954L343.119 273.318 312.744 255.373 312.851 199.846 310.579 198.497 310.465 256.675 343.115 275.954z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M387.504 301.681L354.854 282.402 354.968 224.224 387.617 243.518z",
    opacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__l)",
    fillRule: "nonzero",
    d: "M387.504 301.681L387.507 299.045 357.133 281.101 357.239 225.573 354.968 224.224 354.854 282.402 387.504 301.681z",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M254.788 295.152L222.138 275.873 222.252 217.695 254.898 236.989z",
    opacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__m)",
    fillRule: "nonzero",
    d: "M254.788 295.152L254.792 292.513 224.417 274.572 224.524 219.044 222.252 217.695 222.138 275.873 254.788 295.152z",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M387.504 373.507L354.854 354.228 354.968 296.05 387.617 315.344z",
    opacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__n)",
    fillRule: "nonzero",
    d: "M387.504 373.507L387.507 370.867 357.133 352.927 357.239 297.399 354.968 296.05 354.854 354.228 387.504 373.507z",
    opacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M421.256 161.761L453.906 142.471 454.016 200.649 421.37 219.924z",
    opacity: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__o)",
    fillRule: "nonzero",
    d: "M421.37 219.924L454.016 200.649 453.906 142.471 451.63 143.82 451.74 199.348 421.362 217.288 421.37 219.924z",
    opacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M421.256 233.587L453.906 214.297 454.016 272.471 421.37 291.75z",
    opacity: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__p)",
    fillRule: "nonzero",
    d: "M421.37 291.75L454.016 272.471 453.906 214.297 451.63 215.646 451.74 271.173 421.362 289.114 421.37 291.75z",
    opacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M421.256 305.413L453.906 286.119 454.016 344.297 421.37 363.576z",
    opacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__q)",
    fillRule: "nonzero",
    d: "M421.37 363.576L454.016 344.297 453.906 286.119 451.63 287.468 451.74 342.996 421.362 360.94 421.37 363.576z",
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.107,
    cy: 361.692,
    fill: "#BFC9DD",
    fillRule: "nonzero",
    opacity: 0.3,
    rx: 16.103,
    ry: 8.179
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4FC0",
    fillRule: "nonzero",
    d: "M263.035 361.09s-.806 5.866.367 7.541c1.172 1.676 5.195 2.673 4.7.297-.494-2.375-1.666-9.429-1.666-9.429l-3.4 1.591zM274.533 353.253l-.319 3.446c-.033.41.184.8.55.99l2.033 1.033c.27.139.588.147.865.022l.454-.201s4.03 2.84 8.607 1.048c.013-.522-.302-.997-.788-1.188-1.832-.733-6.192-2.632-7.236-4.534-1.337-2.45-4.166-.616-4.166-.616z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D76F6",
    fillRule: "nonzero",
    d: "M279.926 341.54v12.266s-3.854 2.471-7.811 0c0 0 2.077-17.904 1.583-21.958-.495-4.055 8.94-14.004 8.94-14.004s-.348 19.345-2.712 23.696z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8DFA",
    fillRule: "nonzero",
    d: "M282.63 317.833s.451 5.796-5.976 9.355c0 0-8.698 21.761-8.401 33.133 0 0-3.36 3.666-6.921 0 0 0 .989-23.829 4.942-32.143 0 0-.099-6.925 2.968-9.898 0 .019 7.852 4.212 13.388-.447z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D76F6",
    fillRule: "nonzero",
    d: "M274.833 297.513s1.374-1.543 4.25-.297c3.078 1.334 8.6 4.7 8.6 4.7l.89-3.666s2.276 1.286 4.547.594c0 0 .106 9.139-2.29 9.344-1.7.147-11.402-3.996-14.703-5.58-1.07-.513-1.832-2.437-1.91-3.621-.04-.605.092-1.18.616-1.474z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4FC0",
    fillRule: "nonzero",
    d: "M267.29 299.177l-.594.462c-3.174 2.462-4.052 6.886-2.06 10.375.71 1.186 1.547 2.293 2.496 3.299 0 0 2.374 2.815 2.15 5.19 0 0 7.86 4.748 13.348-.666 0 0 1.528-15.68-3.418-20.02-1.132-.993-2.243-1.99-3.745-1.866-2.983.25-5.827 1.372-8.178 3.226z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C9C6",
    fillRule: "nonzero",
    d: "M267.4 290.815s-.22 4.304 2.15 5.5v1.407s2.52 3.563 5.708 1.558c0 0 2.301 0 2.598-1.778.297-1.778 0-4.766 0-4.766l-10.457-1.92z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4FC0",
    fillRule: "nonzero",
    d: "M269.55 296.307v-2.013s-1.605-1.466-.594-1.833c.436-.186.942-.031 1.199.367.284.378.65.688 1.07.905l.106.055v-2.595l-3.932-.367s-.37 4.22 2.151 5.48z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M265.446 332.727l-5.532-4.153s-2.448-.073-2.004 3.19l6.749 2.672.787-1.709z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M267.4 290.815s2.3 2.006 5.264 2.226c2.151 1.483 4.946 1.655 7.262.447.765-.372 1.207-1.19 1.1-2.035-.1-.627-.528-1.305-1.737-1.748 0 0-.224-6.009-6.005-6.16-5.782-.15-5.885 7.27-5.885 7.27z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C9C6",
    fillRule: "nonzero",
    d: "M262.442 324.065l.817 6.008s-.733 3.633 0 4.377c.733.745 2.37 2.67 4.448 1.335 0 0-2.15-.367-1.63-1.631.52-1.265 2.15-1.038 2.37-.15 0 0 .15-3.263-2.074-3.487l.074-6.863-4.005.411z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5B8B7",
    fillRule: "nonzero",
    d: "M275.258 299.273c-1.241-.044-2.398-.643-3.15-1.632l.582 2.2c.898.17 1.826-.036 2.568-.568z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D76F6",
    fillRule: "nonzero",
    d: "M264.171 303.353s.887-1.929 3.408-1.1c2.52.828 1.78 6.379 1.26 10.011-.52 3.633-2 8.608-1.465 10.386.535 1.778.073 2.599-2.595 2.375-2.667-.223-4.004-2.151-2.744-3.933 1.26-1.782.055-14.99 2.136-17.74z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.982,
    cy: 336.927,
    fill: "#CAD3EA",
    fillRule: "nonzero",
    rx: 2.027,
    ry: 1.07,
    transform: "rotate(-55.71 271.982 336.927)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M273.126 335.231l-5.588-1.961s-.96-.367-1.465.869c0 0-.312.733.319 1.1l4.448 3.35s-.491-2.855 2.286-3.358z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M299.411 281.632L287.782 288.737 283.667 304.632 295.297 297.528z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C9C6",
    fillRule: "nonzero",
    d: "M293.062 298.888s1.868-4.733-.121-4.594c-1.99.14-3.067 4.726-3.33 6.782-.265 2.057 3.385-.938 3.45-2.188z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__r)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M394.066 387.936L467.887 387.936 573.776 327.251 481.209 275.587 481.209 338.809z"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M282.846 109.805L282.846 168.012M326.847 136.69L326.847 194.894M371.181 162.586L371.181 220.793M238.465 84.51L238.465 142.717M282.846 181.517L282.846 239.72M326.847 208.032L326.847 266.235M371.181 234.295L371.181 292.502M238.465 155.855L238.465 214.059M371.181 305.607L371.181 363.811M238.465 227.164L238.465 285.371M437.638 152.399L437.638 210.606M437.638 224.111L437.638 282.314M437.638 295.42L437.638 353.627"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#38AF87",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M81.736 224.29L81.736 238.47"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.736,
    cy: 189.681,
    fill: "#4ACEA5",
    fillRule: "nonzero",
    rx: 35.024,
    ry: 35.042
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M102.301 161.538c4.572 14.42-.623 30.147-12.882 39.002-12.259 8.855-28.814 8.838-41.055-.041 4.588 14.519 18.02 24.413 33.239 24.484 15.219.07 28.742-9.698 33.465-24.174 4.722-14.475-.437-30.345-12.767-39.271z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#38AF87",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M148.746 184.574L148.746 198.757"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.746,
    cy: 149.964,
    fill: "#4ACEA5",
    fillRule: "nonzero",
    rx: 35.024,
    ry: 35.042
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M169.308 121.821c4.578 14.426-.617 30.162-12.883 39.02-12.266 8.859-28.83 8.836-41.073-.055 4.595 14.51 18.025 24.393 33.237 24.462 15.212.069 28.73-9.693 33.456-24.16 4.726-14.468-.42-30.333-12.737-39.267z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#38AF87",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M606.901 283.26L606.901 297.44"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 606.901,
    cy: 248.65,
    fill: "#4ACEA5",
    fillRule: "nonzero",
    rx: 35.024,
    ry: 35.042
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M627.467 220.507c4.578 14.426-.618 30.163-12.885 39.02-12.268 8.858-28.832 8.834-41.074-.059 4.595 14.51 18.023 24.394 33.235 24.464 15.212.07 28.73-9.692 33.457-24.158 4.727-14.467-.418-30.332-12.733-39.267z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "#38AF87",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M539.895 243.547L539.895 257.727"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 539.895,
    cy: 208.934,
    fill: "#4ACEA5",
    fillRule: "nonzero",
    rx: 35.024,
    ry: 35.042
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M560.46 180.795c4.579 14.426-.618 30.163-12.885 39.02-12.267 8.857-28.832 8.834-41.073-.06 4.594 14.51 18.023 24.394 33.234 24.464 15.212.07 28.73-9.691 33.458-24.158 4.727-14.466-.418-30.332-12.733-39.266z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M0.11 30.654L52.402 0.249 69.256 10.07 16.975 40.475z",
    opacity: 0.5,
    transform: "translate(93.797 255.513)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M92.801 255.113L145.093 224.708 148.727 243.353 96.435 273.758z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M90.342 253.691L142.638 223.286 145.093 224.708 92.801 255.113z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M161.049 252.837L163.053 251.627 163.002 265.55 160.994 266.756zM110.736 282.167L112.744 280.972 112.689 294.892 110.681 296.087z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M96.435 273.758L148.727 243.353 163.053 251.627 110.772 282.035z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M92.801 255.033L96.435 273.677 110.772 281.951 110.717 295.874 108.376 294.529 108.405 283.674 96.032 276.694 95.977 287.362 93.907 286.167 93.962 272.248 90.342 253.61z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EDFD",
    fillRule: "nonzero",
    d: "M192.933 363.165L257.855 401.085 247.804 406.914 182.883 368.998 192.933 363.165M176.478 373.998L241.4 411.918 231.346 417.747 166.424 379.827 176.478 373.998"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M0.037 32.879L55.978 0.348 74.019 10.858 18.071 43.393z",
    opacity: 0.5,
    transform: "translate(516.984 375.387)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M588.856 372.605L591.004 371.315 590.945 386.22 588.798 387.5zM535.026 403.992L537.162 402.709 537.107 417.604 534.967 418.883z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M517.08 393.684L574.336 361.692 591.004 371.315 535.055 403.846z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E7FC",
    fillRule: "nonzero",
    d: "M543.903 387.5L535.055 403.761 535.055 403.761 534.996 418.652 532.505 417.219 532.53 405.602 519.293 398.134 519.227 409.55 517.021 408.267 517.08 393.684 532.783 402.537 541.555 386.422z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    d: "M543.903 387.5L597.426 356.992 591.004 371.315 535.026 403.992z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EDFD",
    fillRule: "nonzero",
    d: "M475.054 419.213L485.108 425.046 420.186 462.966 410.132 457.137 475.054 419.217M491.512 430.046L501.566 435.878 436.645 473.795 426.591 467.966 491.512 430.046"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEngineer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/engineer.41eb7fba.svg";
export { ForwardRef as ReactComponent };